var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitecoinSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 456C384 469.254 373.254 480 360 480H88.006C74.75 480 64.006 469.254 64.006 456V270.17L30.193 279.188C28.115 279.734 26.037 280 23.99 280C13.381 280 3.678 272.922 0.818 262.188C-2.604 249.375 5.021 236.219 17.818 232.812L64.006 220.496V56C64.006 42.75 74.756 32 88.006 32S112.006 42.75 112.006 56V207.695L257.818 168.812C270.662 165.406 283.787 173 287.193 185.812C290.615 198.625 282.99 211.781 270.193 215.188L112.006 257.371V432H360C373.254 432 384 442.744 384 456Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoinSign);
export default __webpack_public_path__ + "static/media/litecoin-sign.e3b7131e6cc14ec08c07664ac6988967.svg";
export { ForwardRef as ReactComponent };